import { redirect } from "react-router";
import { IRoutes } from "./interfaces/routes";
import { ROUTES } from "./constants/routes";

export const redirectToLogin = (withoutReturnUrl = false) =>
  redirect(
    withoutReturnUrl || window.location.pathname === "/"
      ? "/login"
      : "/login?returnurl=" + window.location.pathname,
  );

export function getVisningsNavnForRouteId(routeId: keyof IRoutes) {
  for (const routeKey of Object.keys(ROUTES)) {
    const route = ROUTES[routeKey];
    if (route.id === routeId) {
      return route.visningsNavn;
    }
  }
  return "";
}
